import { SenderWarningToast } from './components/SenderWarning';
import PropertySaveProvider from './components/PropertySaveProvider';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './contexts/ThemeContext';
import LandingPage from './components/LandingPage';
import PasswordReset from './components/PasswordReset';
import AdminDashboard from './components/AdminDashboard';
import AgentWinds from './components/AgentWinds';
import InsightsDashboard from './components/InsightsDashboard';
import MailMarketing from './components/MailMarketing';
import MailMarketingMap from './components/MailMarketingMap';
import PropertyListView from './components/PropertyListView';
import Settings from './components/Settings';
import ClientManager from './components/ClientManager';
import ContactSelection from './components/ContactSelection';
import ImageUpload from './components/ImageUpload';
import PostcardSuccess from './components/PostcardSuccess';
import DigitalAds from './components/DigitalAds';
import CreativeManager from './components/CreativeManager';
import FacebookAd from './components/FacebookAd';
import GoogleAd from './components/GoogleAd';
import BlogManager from './components/BlogManager';
import ReviewsManager from './components/ReviewsManager';
import ReviewsPage from './components/ReviewsPage';
import EmailManager from './components/EmailManager';
import AgentReferral from './components/AgentReferral';
import AiStaging from './components/AiStaging';
import BlogPost from './components/BlogPost';
import BlogsPage from './components/BlogsPage';
import ChatPage from './components/ChatPage';
import SitemapXML from './components/SitemapXML';
import ApiDocs from './components/ApiDocs';
import AgentInfo from './components/AgentInfo';
import ContactUs from './components/ContactUs';
import AddContact from './components/AddContact';
import IDXTownPage from './components/IDXTownPage';
import NeighborhoodPage from './components/NeighborhoodPage';
import TermsOfService from './components/TermsOfService';
import PrivacyPolicy from './components/PrivacyPolicy';
import ProtectedRoute from './components/ProtectedRoute';
import SEOPage from './components/seoPages';
import SEOFooter from './components/SEOFooter';
import FloatingContactHub from './components/FloatingContactHub';
import './App.css';
import './components/AssistantTheme.css';

function App() {
  return (
    <ThemeProvider>
      <HelmetProvider>
        <Router>
            <SenderWarningToast />
          <PropertySaveProvider>
        <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/search" element={<LandingPage directSearch={true} />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/listing/:listingKey" element={<LandingPage directListing={true} />} />
          <Route path="/password-reset" element={<PasswordReset />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/agent-winds" element={<ProtectedRoute><AgentWinds /></ProtectedRoute>} />
          <Route path="/admin/insights" element={<ProtectedRoute><InsightsDashboard /></ProtectedRoute>} />
          <Route path="/admin/mail-marketing" element={<ProtectedRoute><MailMarketing /></ProtectedRoute>} />
          <Route path="/admin/mail-marketing/map" element={<ProtectedRoute><MailMarketingMap /></ProtectedRoute>} />
          <Route path="/properties/list" element={<PropertyListView />} />
          <Route path="/admin/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          <Route path="/admin/client-manager" element={<ProtectedRoute><ClientManager /></ProtectedRoute>} />
          <Route path="/admin/mail-marketing/contacts" element={<ProtectedRoute><ContactSelection /></ProtectedRoute>} />
          <Route path="/admin/mail-marketing/upload" element={<ProtectedRoute><ImageUpload /></ProtectedRoute>} />
          <Route path="/admin/mail-marketing/success" element={<ProtectedRoute><PostcardSuccess /></ProtectedRoute>} />
          <Route path="/admin/digital-ads" element={<ProtectedRoute><DigitalAds /></ProtectedRoute>} />
          <Route path="/admin/digital-ads/creative-manager" element={<ProtectedRoute><CreativeManager /></ProtectedRoute>} />
          <Route path="/admin/digital-ads/ai-staging" element={<ProtectedRoute><AiStaging /></ProtectedRoute>} />
          <Route path="/admin/digital-ads/facebook" element={<ProtectedRoute><FacebookAd /></ProtectedRoute>} />
          <Route path="/admin/digital-ads/google" element={<ProtectedRoute><GoogleAd /></ProtectedRoute>} />
          <Route path="/admin/blog-manager" element={<ProtectedRoute><BlogManager /></ProtectedRoute>} />
          <Route path="/admin/reviews" element={<ProtectedRoute><ReviewsManager /></ProtectedRoute>} />
          <Route path="/admin/email-manager" element={<ProtectedRoute><EmailManager /></ProtectedRoute>} />
          <Route path="/admin/agent-referral" element={<ProtectedRoute><AgentReferral /></ProtectedRoute>} />
          <Route path="/blogs" element={<BlogsPage onClose={() => window.history.back()} />} />
          <Route path="/reviews" element={<ReviewsPage onClose={() => window.history.back()} />} />
          <Route path="/agent" element={<AgentInfo />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/add-contact" element={<AddContact />} />
          <Route path="/neighborhood/idxtown" element={<IDXTownPage />} />
          <Route path="/neighborhood/:citySlug" element={<NeighborhoodPage />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/sitemap.xml" element={<SitemapXML />} />
          <Route path="/api-docs" element={<ApiDocs />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/:slug" element={<SEOPage />} />
        </Routes>
          <FloatingContactHub />
        <SEOFooter />
        </div>
        </PropertySaveProvider>
          </Router>
      </HelmetProvider>
    </ThemeProvider>
  );
}

export default App;
